<template>
    <div class="SitePlanEstimator">
        <div class="header">
            <div class="plan">
                <div class="price">${{ cost }}</div>
                <h5>Per driver / month</h5>
            </div>

            <div class="input">
                <strong>How many drivers?</strong>
                <FormNumber v-model="drivers" :min="1" :max="5000" class="marginless"/>
            </div>
        </div>

        <div class="main">
            <h3>Calculated total</h3>
            <div class="totalPrice">
                <strong>{{ drivers * cost | formatCurrency }}</strong>/mo
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SitePlanEstimator',

    props: {
        cost: { type: Number },
    },

    syncProps: ['drivers'],
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SitePlanEstimator {
    .header {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .plan {
        margin-right: 60px;

        h5 {
            font-weight: $font-weight-regular;
        }

        .price {
            font-size: 42px;
            font-weight: $font-weight-bold;
        }
    }

    .input {
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    .main {
        margin-top: 40px;

        .totalPrice {
            font-size: 36px;
        }
    }

    .FormNumber {
        max-width: 150px;
        text-align: center;
        font-size: 22px;
    }
}
</style>
